export default function encode(str) {
    return encodeURIComponent(str);
}
